// extracted by mini-css-extract-plugin
export default {"heading":"_4rivuRWK","subList":"_3f5Ghicw","venueList":"Ol4AqPNI"};